module.exports = require('date-fns/startOfWeek').startOfWeek;
